import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d3cpxt2ubz: FaireBrandEntity = {
  token: "b_d3cpxt2ubz",
  type: "brand",
  name: "Design Carolinas",
  avatarUrl:
    "https://cdn.faire.com/fastly/8c3ef85120d57fe516f67ba455c4919a86b2a313582b70e709c90cc1dd29ffd5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b4e55a56dbd32f2e398cc824da40d4c06e50bcd036733fce0707545fcfb3871e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8c3ef85120d57fe516f67ba455c4919a86b2a313582b70e709c90cc1dd29ffd5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b4e55a56dbd32f2e398cc824da40d4c06e50bcd036733fce0707545fcfb3871e.png",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Design Carolinas was inspired by owner and designer Belle's southern roots; throughout her designs timeless patterns are given new life with bright colors and custom monograms. Featuring stationery, post-it notes, note pads, gifts tags, wrapping paper, (and more), these designs make writing and gifting more fun!\n\nBelle lives in Charlotte, NC with her husband, two sons and Bernedoodle Heidi. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:32.233Z",
    importedBy: "entity-db-cli",
  },
};
